import { IGetInspecaoMaquinasEquipByIdUseCase } from "../../../presentation/useCases/read/get_inspecao_maquinas_equip_by_id_use_case";
import { InspecaoMaquinaEquipDetalhes } from "../../models/inspecao_maquinas_equip_detalhes";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetInspecaoMaquinasEquipByIdUseCase
 */

export class GetInspecaoMaquinasEquipByIdUseCase implements IGetInspecaoMaquinasEquipByIdUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async getInspecaoMaquinasEquipById(
    idControleCentroCusto: number,
    idInspecaoMaquinaEquip: number | undefined,
  ): Promise<InspecaoMaquinaEquipDetalhes> {
    if (idControleCentroCusto === undefined) throw new Error("Falha ao obter id do controle decentro de custo!");
    if (idInspecaoMaquinaEquip === undefined) throw new Error("Falha ao obter id da inspeção da máquina/equipamento!");
    const response = await this.repository.getInspecaoMaquinasEquipById(idControleCentroCusto, idInspecaoMaquinaEquip);
    if (response === null) throw new Error("Falha ao obter detalhes da inspeção da máquina/equipamento!");
    return response;
  }
}
